/* eslint-disable react-hooks/rules-of-hooks */
// Dependencies
import React, { useEffect, useContext, useState, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/react-hooks';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import browserPath from 'path-browserify';
// import browserPath from 'path';
import { append, concat, filter, forEach, includes, isEmpty, map, path, pathOr, uniqBy, without } from 'ramda';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// import FormControl from '@material-ui/core/FormControl';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

// Components
import { KeycloakContext } from 'components/Secured';
import Vision from 'components/vision';
import InputTextField, { InputTextFieldDebounced } from 'components/inputfields/InputTextField';
// import FloatInput from './FloatInput';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';
import ImageUploader from 'components/fileuploader/ImageUploader';
import InputLabel from 'components/inputfields/InputLabel';
import ListDropDown from 'components/inputfields/ListDropDown';
import MultipleSelect from 'components/inputfields/MultipleSelect';
import ImageSorter from 'components/images/ImageSorter';
import CircularSpinner from 'components/loadingIndicator/CircularSpinner';
import MarkedProduct from 'components/product/MarkedProduct';
// import StockToggleButton from '../StockToggleButton';
import { ResponseSnackBar } from 'components/snackbar/SnackBar';
import Chat from 'components/chat';

// Constants
import COLORS from 'constants/colors';
import { LINKS } from 'constants/domain';
import { SUPERUSER_APPROVAL, APPLICATION_ROLES, PRODUCT_STATUS } from 'components/constants';
import { preparedForm, additionalCharacteristics, categoryWeightloss } from 'components/constants-ts';

// Hooks
import useCategoriesData from 'hooks/useCategoriesData';

// Mutations
import {
  MUTATION_SUPERUSER_APPROVE,
  S3_SIGNED_REQUEST_MUTATION,
  MUTATION_ADD_PRODUCT,
  MUTATION_REMOVE_PRODUCT,
  MUTATION_RESTORE_PRODUCT,
  MUTATION_PRODUCER_UPDATE_PRODUCT,
} from 'graphql/mutations';

// Queries
import {
  // SUPERUSER_STATISTICS_QUERY,
  PRODUCT_INFO_FOR_UPDATE_QUERY,
  // ALL_PRODUCTS_QUERY,
  GET_PRODUCT_BY_ID,
  CHECK_UNIQ_EAN,
  PRODUCT_EDIT_HISTORY_QUERY,
} from 'graphql/queries';

// Utils
import { isDefined } from 'utils/helpers';
import { uploadImages, getImagesForSorter } from 'utils/images';
import { extractProductImagesToSingleArray } from 'utils/images2';

import { requiredNutritionalFields } from './constants';
import SubmitButton, { checkEanErrorForIcaStoreProducer } from './SubmitButton';
import useStyles from './useStyles';
import { getInitialState, getShowRed, getProductMutationInput } from './utils';
import { getProductFieldVisibility } from './utils/productFieldVisibility';
import Alerts from './alerts';
import Address from './fields/address';
import Brand from './fields/brand';
import Category, {
  isNewFood,
  isJewelry,
  isElectric,
  isToy,
  isChemical,
  isDetergent,
  isSunscreen,
  isCosmetic,
  isCmrHazardCategory,
  isFeedMaterial,
  isFeedMixtures,
  isCompleteFeed,
  removeUnnecessaryAprroveFields,
} from './fields/category';
import Descriptive from './fields/descriptive';
import Dimensions from './fields/dimensions';
import GrossWeight from './fields/gross-weight';
import Ingredients from './fields/ingredients';
import Labels from './fields/labels';
import NonFoodIngredients from './fields/non-food-ingredients';
import Nutrition from './fields/nutrition';
import Vitamins from './fields/vitamins';
import OtherSubstances from './fields/other-substances';
// import PackageSize from './fields/package-size';
import ProducerInfo from './fields/producer';
import BulkImportFile from './fields/bulk-import-file';
import ProducerNotAccepted from './fields/producer-not-accepted';
import Review from './fields/review';
import Title from './fields/title';
import Temperature from './fields/temperature';
import GrossDimensions from './fields/gross-dimensions';
import SearchTerms from './fields/search-terms';
import GenericField from './fields/generic-field';
import CountryOfManufacturing from './fields/country-of-manufacturing';

import { isWrongCoopStoreEAN } from './alerts-check';

import AlternativeTitle from './fields/alternative-title';
// import Pallet from './fields/pallet';
// import PalletLayer from './fields/pallet-layer';
// import Transport from './fields/transport';
// import Price from './fields/price';
import PurchasingData from './fields/purchasing-data';
import ShortSalesDescription from './fields/short-sales-description';
import FishFields from './fields/fish-fields';
import FeedFields from './fields/feed-fields';
import AnimalFields from './fields/animal-fields';
import HazardFields from './fields/hazard-fields';
import AdditionalGroupFields from './fields/additional-group-fields';
import ProductDocuments from './fields/product-documents';
import FeedApprovalFields from './fields/feed-approval';
import SunScreenFields from './fields/sun-screen-fields';
import CmrFields from './fields/cmr-fields';
import ReachSubstancesFields from './fields/reach-substances-fields';
import HazardousSubstancesFields from './fields/hazardous-substances-fields';
import MedicalTechnologyFields from './fields/medical-technology-fields';
import QualityReviewFields from './fields/quality-review-fields';
import OrderableUnitFields from './fields/orderable-unit-fields';
import DespatchUnitFields from './fields/despatch-unit-fields';
import EANForStorePack from './fields/ean-for-store-pack-fields';
import QtyOfBaseItemFields from './fields/qty-of-base-item-fields';
// import ConsumerPack from './fields/consumer-pack';
// import StorePack from './fields/store-pack';
import BasicData from './fields/basic-data';
import ShortText from './fields/short-text';
// import Details from './fields/details';
import useUnpaidInvoiceData from 'hooks/useUnpaidInvoiceData';
import Approvements from './approvements';
import PurchaseRelatedFields from './fields/purchase-related-fields';

import useViewport from 'hooks/useViewports';
import FillProductByImage, { useUploadRecognizeImages } from './FillProductByImage';
import useAdminOrg from 'hooks/useAdminOrg';
import ReadOnlyImageGallery from '../ReadOnlyImageGallery';
import LogisticQuestionsWrapper from './LogisticQuestionsWrapper';
import ReachSubstance from './fields/reach-substance';
import { isBlank } from 'utils/helpers-ts';
import AIReviewer from './AIReviewer';
import { AiFieldVerdictContext, failedAiVerdicts } from './AiFieldVerdict';
import TagLabel from 'components/TagLabel';
import SalesType from './fields/sales-type';
import useSearchParams from 'hooks/useSearchParams';
import FirstProductDialog from 'components/FirstProductDialog';
import { useAppContext } from 'AppContext';
import AlertDialog from 'components/AlertDialog';
import useIcaExportData from './ica-export/useIcaExportData';
import useApoteaJsonExportData from './apotea-export/useApoteaJsonExportData';
import useCoopExportData from './coop-export/useCoopExportData';
import { trackCreateProductFormView } from 'utils/ga4Tracking';
import useApoteaExportData from './apotea-export/useApoteaExportData';
import WhiteSnus from './fields/white-snus';
import ConsumerContact from './fields/consumer-contact';
import AnimalFeedType from './fields/animal-feed-type';
import SewingKnittingYarn from './fields/sewing-knitting-yarn';
import ImageHistory from './history/ImageHistory';
import ProductEditHistory from '../ProductEditHistory';
import { ProductEditHistoryContext } from './ProductEditHistoryContext';
import { FieldHistoryIcon } from './FieldHistoryIcon';
import useLoadProductVersions from 'hooks/useLoadProductVersions';
import BurningTime from './fields/burning-time';
import ApoteaPrices from './fields/apotea-prices';
import CommodityCode from './fields/commodity-code';
import { useProductDocuments } from './fields/product-documents';
import ElectricLamp from './fields/electric-lamp';
import CancelImportImageButton from './CancelImportImageButton';
import useImportProductImages from './useImportProductImages';
import Batteries from './fields/batteries';
import { Divider } from '@material-ui/core';
import { ProductValidationContext } from './validation-context/ProductValidationContext';
import { evaluateProductValidations } from './validation-context/evaluateProductValidations';
import RequiredAsterisk from './validation-context/RequiredAsterisk';

const ApoteaExportPreview = React.lazy(() =>
  import(/* webpackChunkName: "apotea-export-preview.component" */ './apotea-export/ApoteaXml')
);
const ApoteaExportJsonPreview = React.lazy(() =>
  import(/* webpackChunkName: "apotea-export-json-preview.component" */ './apotea-export/ApoteaJson')
);
const IcaExportPreview = React.lazy(() =>
  import(/* webpackChunkName: "ica-export-preview.component" */ './ica-export/IcaProductJson')
);
const CoopExportPreview = React.lazy(() =>
  import(/* webpackChunkName: "coop-export-preview.component" */ './coop-export/CoopExportJson')
);
const WoltExportPreview = React.lazy(() =>
  import(/* webpackChunkName: "wolt-export-preview.component" */ './export-preview/wolt')
);

// FC-2041: the edit pages unmount this form while they refetch a saved product,
// so the success message is carried over that reload in sessionStorage.
const SAVED_FEEDBACK_KEY = 'productSavedFeedback';

const ignoreTabsFields = [
  'title',
  'EAN',
  'short_text',
  'ingredient_statement',
  'trade_item_temperature_information',
  'place_of_item_activity',
  'additional_required_information',
  'search_terms',
  'brand_food',
  'location',

  'brand',
  'color',
  'material',
  'non_food_ingredients',
  'dimensions',
  'capacity',
  // 'country_of_origin',
];

const getControlDigit = ean => {
  if (ean) {
    const EAN = ean.trim();
    if (EAN.length === 13 || EAN.length === 12) {
      const total =
        parseInt(EAN[0]) +
        parseInt(EAN[2]) +
        parseInt(EAN[4]) +
        parseInt(EAN[6]) +
        parseInt(EAN[8]) +
        parseInt(EAN[10]) +
        3 *
          (parseInt(EAN[1]) +
            parseInt(EAN[3]) +
            parseInt(EAN[5]) +
            parseInt(EAN[7]) +
            parseInt(EAN[9]) +
            parseInt(EAN[11]));
      let control = 10 - (total % 10);
      if (control === 10) control = 0;
      return control;
    }
  }
  return undefined;
};

export const checkEANValue = (state, uniqResult, isCreatingNew) => {
  const checkEAN = ean => {
    const EAN = ean.trim();
    if (EAN.length === 13) {
      const control = getControlDigit(ean);
      return control === parseInt(EAN[12]);
    }
    return true;
  };

  let eanLengthError;
  let eanControlError;
  let eanWrongCoopStoreError;
  let nonUniqError;
  if (state.EAN && state.EAN.trim() !== '' && !uniqResult) {
    if (state?.producerIsStore) {
      nonUniqError =
        'Det verkar som om att du redan använt denna EAN-kod på en av dina produkter i Sygrid, vänligen ange en annan EAN-kod.';
    } else {
      nonUniqError =
        'Det verkar som om att EAN-koden du försöker ange redan existerar i Sygrid, vänligen ange en annan EAN-kod. Kontakta oss på support@sygrid.com om det verkar som om någon annan har använt din produkts EAN-kod!';
    }
  }

  if (state.EAN && state.EAN.trim() !== '' && state.EAN.trim().length !== 8 && state.EAN.trim().length !== 13) {
    eanLengthError =
      "Vänligen ange konsumentförpackningens EAN-kod med 8 eller 13 siffror. Har du en 12-siffrig UPC-kod? Lägg till en '0' först för att göra den 13 siffror.";
  } else if (
    state.EAN &&
    state.EAN.trim().length === 13 &&
    !state.EAN.trim().startsWith('23') &&
    !state.EAN.trim().startsWith('2000') &&
    !state.EAN.trim().startsWith('2095') &&
    !state.EAN.trim().startsWith('2096') &&
    !state.EAN.trim().startsWith('2097') &&
    !checkEAN(state.EAN)
  ) {
    eanControlError = `Kontrollsiffran (sista siffran i EAN-koden) "${state.EAN[12]}" är felaktig.`;
  } else {
    eanLengthError = undefined;
    eanControlError = undefined;
  }

  if (state?.EAN && state.EAN.trim() !== '' && isWrongCoopStoreEAN(state)) {
    eanWrongCoopStoreError =
      'Det verkar som ni har angett en EAN-kod som inte tillhör det range som Coop Online har godkänt för butiksproducerade artiklar online. För att vi ska kunna släppa igenom produkten till coop.se, vänligen vårda om produkten för försäljning på en EAN-kod som inleds med följande siffror och ange samma EAN-kod på produkten i Sygrid: 20001, 20002, 20003, 20004, 20005, 20006, 20007, 20008, 200090000000, 20975, 20976, 20977, 20978, eller 20979. Om artikeln kommer från en extern leverantör får ni gärna meddela support@sygrid.com så hjälper vi till att få upp artikeln via leverantören. Informera oss då om leverantörens namn och om möjligt en kontaktperson hos leverantören.';
  } else {
    eanWrongCoopStoreError = undefined;
  }

  const eanNotOnlyDegit = !!state.EAN && /[^0-9]/.test(state.EAN);
  const icaStoreProcucerEanError = checkEanErrorForIcaStoreProducer(state, isCreatingNew);

  return {
    eanLengthError,
    eanControlError,
    eanWrongCoopStoreError,
    nonUniqError,
    eanNotOnlyDegit,
    icaStoreProcucerEanError,
  };
};

const ProductForm = ({
  showTitleHeader,
  producerData,
  isCreatingNew,
  product,
  userRole,
  approve,
  refetchQuery,
  refetchVariables,
  productLoading,
  readOnly,
}) => {
  const { searchParams } = useSearchParams();
  const { mdUp } = useViewport();
  const keycloakCtx = useContext(KeycloakContext);
  const { allProductCount } = useAppContext();
  const token = path(['keycloak', 'token'], keycloakCtx);
  const isUserStore = keycloakCtx.keycloak.hasResourceRole('store');

  const enableChat = process.env.REACT_APP_ENABLE_CHAT === 'true';
  const isLocal = process.env.REACT_APP_AUTH_ENV === 'local';
  const isDev = process.env.REACT_APP_AUTH_ENV === 'dev';
  const classes = useStyles();
  const allExistingProductImages = isCreatingNew ? [] : extractProductImagesToSingleArray(product);
  const imagesForSorter = getImagesForSorter(allExistingProductImages);

  const initialState = getInitialState(
    isCreatingNew
      ? {
          EAN: searchParams.ean,
          title: searchParams.title,
        }
      : product,
    producerData,
    isCreatingNew
  );
  const isProducer = userRole === APPLICATION_ROLES.PRODUCER || userRole === APPLICATION_ROLES.STORE;
  const isSuperuser = userRole === APPLICATION_ROLES.SUPERUSER;
  const isApoteaProducer = isProducer && producerData?.organizations?.includes('apotea');

  const viewStartTime = useRef(null);

  const keepRef = useRef({});

  const [state, setState] = React.useState(initialState);
  // The product as saved, to tell a field changed in the form from one saved with another value.
  const savedState = useMemo(
    () => (isSuperuser ? getInitialState(isCreatingNew ? {} : product, producerData, isCreatingNew) : null),
    [isSuperuser, product, producerData, isCreatingNew]
  );
  // Superusers see what the AI review failed under each field; the review in the form, so a new one shows at once.
  const aiFieldVerdicts = useMemo(
    () => (isSuperuser ? failedAiVerdicts(state?.aiReview, state?.aiReviewRunSummary, state, savedState) : {}),
    [isSuperuser, state, savedState]
  );

  const [uploadDone, setUploadDone] = React.useState(false);
  const [imageIsUploading, setImageIsUploading] = React.useState(false);
  const [imageUploadError, setImageUploadError] = React.useState(false);
  const [sortedImages, setImagesSorted] = React.useState(imagesForSorter);
  const [imagesToBeRemoved, setImagesToBeRemoved] = React.useState([]);
  const [autofillFiles, setAutofillFiles] = React.useState([]);
  const [fillImagesToBeRemoved, setFillImagesToBeRemoved] = React.useState([]);
  const [imagesRejected, setImagesRejected] = React.useState([]);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [approved, setApproved] = React.useState(true);
  const [isDespatchUnitsChanged, setIsDespatchUnitsChanged] = React.useState(false);
  const [woltExportData, setWoltExportData] = React.useState({});
  const [isAiChangedState, setIsAiChangedState] = useState(false);
  const [isChangedBrand, setChangedBrand] = useState(false);
  const [isCreatedFirstProduct, setIsCreatedFirstProduct] = useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const [historyExpanded, setHistoryExpanded] = React.useState(false);
  const [highlightedField, setHighlightedField] = React.useState(null);

  const { data: historyData, loading: historyLoading } = useQuery(PRODUCT_EDIT_HISTORY_QUERY, {
    variables: { id: state.id },
    skip: !isSuperuser || !state.id || isCreatingNew
  });

  const expandHistoryAndScroll = React.useCallback((name) => {
    setHistoryExpanded(true);
    setHighlightedField(name);
    setTimeout(() => {
      const el = document.getElementById('product-edit-history-section');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  }, []);

  const isCoopStoreProduct = !!state.producerIsStore && state.producerOrg?.startsWith('coop/');
  const isApoteaProductProducer = !!state?.producerOrganizations?.includes('apotea');
  const adminOrg = useAdminOrg();
  const showApoteaFields =
    (isSuperuser && isApoteaProductProducer) || isApoteaProducer || (adminOrg === 'apotea' && isApoteaProductProducer);

  const unpaidInvoiceData = useUnpaidInvoiceData({ skip: readOnly });
  const icaExportData = useIcaExportData({
    isProducerOrStore: isProducer,
    isSuperuser,
    state,
    images: sortedImages,
    producerData,
    isSubmitting,
  });
  const coopExportData = useCoopExportData({
    isProducerOrStore: isProducer,
    isSuperuser,
    state,
    images: sortedImages,
    producer: product?.producer,
    producerData,
    isSubmitting,
  });
  const apoteaExportData = useApoteaExportData({
    isProducerOrStore: isProducer,
    isSuperuser,
    state,
    images: sortedImages,
    producerData,
    isSubmitting,
  });
  const apoteaJsonExportData = useApoteaJsonExportData({
    isProducerOrStore: isProducer,
    isSuperuser,
    state,
    images: sortedImages,
    producerData,
    isSubmitting,
  });
  // FC-2064: the export previews return the manual name when one is set, so superusers
  // get a second preview without the overrides to show the generated name next to it.
  const generatedNameState = useMemo(
    () => ({ ...state, icaExportTitle: '', apoteaExportTitle: '' }),
    [state]
  );
  const icaGeneratedNameData = useIcaExportData({
    isSuperuser,
    state: generatedNameState,
    images: sortedImages,
    producerData,
    isSubmitting,
    skip: !isSuperuser || isBlank(state?.icaExportTitle),
  });
  const apoteaGeneratedNameData = useApoteaJsonExportData({
    isSuperuser,
    state: generatedNameState,
    images: sortedImages,
    producerData,
    isSubmitting,
    skip: !isSuperuser || isBlank(state?.apoteaExportTitle),
  });
  const { onUploadRecognizeImages } = useUploadRecognizeImages({ state });

  const { onUploadProductDocuments } = useProductDocuments();
  const { loadingVersions, loadedVersions, versions, triggerLoadVersions } = useLoadProductVersions(state);

  const [restoreProductMutation] = useMutation(MUTATION_RESTORE_PRODUCT, {
    refetchQueries: refetchQueries(),
    awaitRefetchQueries: true,
  });

  const { loading: categoryLoading, error: categoryError, rootCategory, categories } = useCategoriesData();
  const { sections: visibleSections, fields: visibleFields } = getProductFieldVisibility({
    product: state,
    rootCategory,
    showApoteaFields: !!showApoteaFields,
  });

  // FC-1950: retailer-required fields gate activation of new products and saved drafts only,
  // so an already active product can be re-saved without them (grandfathering).
  const applyRetailerRules = !!isCreatingNew || !!product?.isDraft;
  // Product-information files that will remain after saving, counted like the submit does:
  // saved files not marked for removal plus new uploads not marked for removal.
  const productInfoFilesCount = useMemo(() => {
    const keptSaved = (state?.recognizeImages || []).filter(
      item => !fillImagesToBeRemoved.some(({ url }) => url === item.url)
    ).length;
    const keptNew = autofillFiles.filter(
      item => !item.recognized && !fillImagesToBeRemoved.some(({ file }) => file === item.file)
    ).length;
    return keptSaved + keptNew;
  }, [state?.recognizeImages, autofillFiles, fillImagesToBeRemoved]);
  const productValidations = useMemo(
    () =>
      evaluateProductValidations({
        state,
        rootCategory,
        productInfoFilesCount,
        applyRetailerRules,
      }),
    [state, rootCategory, productInfoFilesCount, applyRetailerRules]
  );

  const [removeProductMutation] = useMutation(MUTATION_REMOVE_PRODUCT, {
    refetchQueries: refetchQueries(),
  });

  const isGranularCategory = () => {
    if (categories && state?.foodlaCategory?.id) {
      const category = categories.find(x => x.parentCategoryId === state.foodlaCategory.id);
      if (category) return false;
    }
    return true;
  };
  const showCategoryError =
    isSuperuser &&
    !categoryLoading &&
    !productLoading &&
    (!state?.foodlaCategory?.id || state.foodlaCategory.id.trim() === '' || !isGranularCategory());

  useEffect(() => {
    sessionStorage.removeItem('createdNewProduct');
  }, []);

  const [savedFeedback] = useState(() => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(SAVED_FEEDBACK_KEY) || 'null');
      return stored && stored.productId === product?.id ? stored : null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    sessionStorage.removeItem(SAVED_FEEDBACK_KEY);
  }, []);

  useEffect(() => {
    const allExistingProductImages = isCreatingNew ? [] : extractProductImagesToSingleArray(product);
    const imagesForSorter = getImagesForSorter(allExistingProductImages);
    setImagesSorted(imagesForSorter);
  }, [isCreatingNew, product]);

  React.useEffect(() => {
    if (state.approve) {
      console.log('!!!approve', state.approve);
    }
  }, [state?.approve]);

  useEffect(() => {
    setState(getInitialState(product, producerData, isCreatingNew));
    // if (product?.adminStatus === SUPERUSER_APPROVAL.ADMIN_APPROVED) {
    //   setState({...state, approve: []});
    // }
  }, [product, producerData, isCreatingNew]);

  React.useEffect(() => {
    const event = isCreatingNew ? 'createProductView' : 'updateProductView';
    window.dataLayer.push({
      event: event,
      product: {
        id: state?.id,
        name: state?.title,
        foodlaCategory: state?.foodlaCategory?.name,
      },
    });

    if (isCreatingNew) {
      viewStartTime.current = Date.now();
    }
  }, [isCreatingNew]);

  useEffect(() => {
    const userId = keycloakCtx?.keycloak?.tokenParsed?.sub;
    if (searchParams.source) {
      trackCreateProductFormView({
        userId,
        flowId: searchParams.flowId,
        source: searchParams.source,
        ean: searchParams.ean,
      });
    }
  }, [keycloakCtx?.keycloak?.tokenParsed?.sub, searchParams.ean, searchParams.flowId, searchParams.source]);

  // check approve status for product's fields (superuser)
  React.useEffect(() => {
    if (state && state.approve && state.approve.length > 0 && isSuperuser && approve) {
      const approveList = removeUnnecessaryAprroveFields(state, rootCategory);
      const hasNotApprovedField = approveList.some(x => x.state !== true);
      setApproved(!hasNotApprovedField);
    } else {
      setApproved(true);
    }
  }, [state, state.approve, isSuperuser, approve, product, rootCategory]);

  React.useEffect(() => {
    if (readOnly) return; // admin preview: don't fire the admin-forbidden checkUniqEAN refetch or recompute EAN2
    if (state) {
      let ean;
      let disable = true;
      if (state.EAN) {
        ean = state.EAN.trim();
        checkUniqEAN({
          id: state.id,
          EAN: state?.EAN,
          EAN2: state?.EAN2,
          storeId: state?.producerIsStore ? state?.producerId : null,
        });
      }
      if (
        ean &&
        ean.length === 13 &&
        (ean.startsWith('23') ||
          ean.startsWith('2095') ||
          ean.startsWith('2096') ||
          ean.startsWith('2097') ||
          ean.startsWith('2000'))
      ) {
        if (ean[8] !== '0' || ean[9] !== '0' || ean[10] !== '0' || ean[11] !== '0') {
          let newEan = ean.substring(0, 8) + '0000';
          const control = getControlDigit(newEan);
          if (!isNil(control)) {
            newEan += control.toString();
          }
          disable = false;
          setState({ ...state, EAN2: newEan });
        } else if (ean[8] === '0' && ean[9] === '0' && ean[10] === '0' && ean[11] === '0') {
          const control = getControlDigit(ean);
          if (!isNil(control)) {
            if (control.toString() !== ean[12]) {
              const newEan = ean.substring(0, 12) + control.toString();
              disable = false;
              setState({ ...state, EAN2: newEan });
            }
          }
        }
      }
      if (disable) {
        setState({ ...state, EAN2: null });
      }
    }
  }, [state.EAN]);

  const history = useHistory();

  keepRef.current.sortedImages = sortedImages;

  // ---------- MUTATIONS ---------- //

  const [s3SignedRequest, { data: requestData, error: requestError, loading: requestLoading }] = useMutation(
    S3_SIGNED_REQUEST_MUTATION,
    {
      refetchQueries: [],
      onCompleted: data => {
        const requests = data?.getS3SignRequest?.requests || [];
        const isAiImprovedImage = requests[requests.length - 1]?.pictureUrl?.includes('_AIIMPROVED');

        const allExistingImages = extractProductImagesToSingleArray(product);
        const imagesForSorter = getImagesForSorter(allExistingImages, data, keepRef.current.files, {
          prioritizeNewAiImage: true,
          lastAiImproveAsMain: isAiImprovedImage,
          sortedImages: keepRef.current.sortedImages || [],
        });
        setImagesSorted(imagesForSorter);
      },
    }
  );

  // Using special mutation for images that is to large. We don't want to trigger the onCompleted function then.
  const [s3SignedRequestForLargeFiles] = useMutation(S3_SIGNED_REQUEST_MUTATION, {
    refetchQueries: [],
  });

  const isDownload = isSuperuser;
  const isEdit = isSuperuser;

  const refQuery = () => {
    if (!isCreatingNew && refetchQuery) {
      refetchQuery({ id: product.id });
    }
  };
  const [
    updateProduct,
    {
      data: updateProductData,
      loading: updateProductLoading,
      error: updateProductError,
      refetch: updateProductRefetch,
    },
  ] = useMutation(isSuperuser ? MUTATION_SUPERUSER_APPROVE : MUTATION_PRODUCER_UPDATE_PRODUCT, {
    refetchQueries,
    awaitRefetchQueries: true,
    onError: () => {
      setIsSubmitting(false);
    },
    onCompleted: data => {
      setIsSubmitting(false);
      if (data?.updateProduct?.success) {
        // The sorter is rebuilt from the refetched product (see the `product` effect),
        // so the removal marks must go now or they would be subtracted from the fresh list.
        setImagesToBeRemoved([]);
        setFillImagesToBeRemoved([]);
        // setState({...state, product});
        if (refetchQuery) {
          sessionStorage.setItem(
            SAVED_FEEDBACK_KEY,
            JSON.stringify({
              productId: product.id,
              message: getUpdateSuccessMessage(data),
              additionalSuccess: !imageUploadError,
              additionalMessage: imageUploadError
                ? 'Failed to upload images. Contact support for help.'
                : uploadDone
                ? 'Images uploaded!'
                : '',
            })
          );
          refetchQuery({ id: product.id });
          // if (refetchVariables) {
          //   refetchQuery(refetchVariables);
          // } else {
          //   refetchQuery();
          // }
        }
      }
      // setState(data)
      // refetchQueries();
    },
  });

  const [createProductMutation, { data: createProductData, loading: createProductLoading, error: createProductError }] =
    useMutation(MUTATION_ADD_PRODUCT, {
      refetchQueries: refetchQueries(),
      awaitRefetchQueries: true,
      onError: () => {
        setIsSubmitting(false);
        // FC-2041: the form is reset before a new product is saved,
        // so a failed save gets back the entered fields and images (already uploaded) for a retry.
        if (keepRef.current.savingState) setState(keepRef.current.savingState);
        if (keepRef.current.savingImages) setImagesSorted(keepRef.current.savingImages);
      },
      onCompleted: () => {
        setIsSubmitting(false);
        sessionStorage.setItem('createdNewProduct', keepRef.current.savingState?.isDraft ? 'draft' : 'true');
        if (keepRef.current.savingState?.producerIsStore) {
          let path = '/me/products';
          if (keepRef.current.savingState?.isDraft) {
            path += '?tab=draftProducts';
          }
          history.push(path);
        } else {
          if (allProductCount) {
            let path = '/products';
            if (keepRef.current.savingState?.isDraft) {
              path += '?tab=draftProducts';
            }
            history.push(path);
          } else {
            setIsCreatedFirstProduct(true);
          }
        }
      },
    });

  const { data: uniqEANResult, refetch: checkUniqEAN } = useQuery(CHECK_UNIQ_EAN, {
    variables: {
      id: state.id,
      EAN: state?.EAN,
      EAN2: state?.EAN2,
      storeId: state?.producerIsStore ? state?.producerId : null,
    },
    fetchPolicy: 'no-cache',
    skip: readOnly,
  });

  const productStatus = pathOr('', ['productStatus'], product);
  const markedForRemoval = productStatus === PRODUCT_STATUS.MARKED_FOR_REMOVAL;
  const markedDeleted = productStatus === PRODUCT_STATUS.DELETED;
  const showMarkedForRemovalComponent = isProducer && markedForRemoval;
  const showMarkedComponent = (isProducer && markedForRemoval) || markedDeleted;

  // FC-1849: DO NOT unmount the form during submission (e.g., using a conditional render like showForm && <form>).
  // Unmounting destroys the tree, triggering AbortController cleanups in export-preview hooks
  // and potentially killing the active useMutation network request. Use CSS `display: none` instead.
  const formHidden = updateProductLoading || imageIsUploading || createProductLoading || isSubmitting;
  const isFood = isNewFood(state?.foodlaCategory, rootCategory);

  // return true when api had not be called successfully
  const uniqResult = uniqEANResult ? uniqEANResult.checkUniqEAN : true;
  // console.log('!uniqResult', uniqResult);

  useEffect(() => {
    setState(oldState => {
      const showRed = getShowRed(oldState, isFood);
      return { ...oldState, showRed };
    });
  }, [...requiredNutritionalFields.map(x => state[x]), isFood]);

  // ------------------------------- //

  const getNewName = name => {
    if (name) {
      const ext = browserPath.parse(name).ext;
      return `${Date.now()}_${state.EAN}${name.includes('AIGENERATED') ? '_AIGENERATED' : ''}${ext}`;
    }
    return name;
  };
  const getS3Requests = (images, isLargeFilesRequest) => {
    // console.log('!!!files1', images);
    // const files = images.map(i => ({ fileName: getNewName(i.name), fileType: i.type }));
    // An improved image carries the id of its image improvement run, which keeps the upload.
    const files = images.map(i => ({
      fileName: i.name,
      fileType: i.type,
      ...(i.imageImproveId ? { imageImproveId: i.imageImproveId } : {}),
    }));
    // console.log('!!!files2', files);
    const mutationMethod = isLargeFilesRequest ? s3SignedRequestForLargeFiles : s3SignedRequest;

    return mutationMethod({
      variables: {
        input: {
          isProduct: true,
          files,
          producerName: isCreatingNew ? path(['name'], producerData) : path(['producer', 'name'], product),
          producerUsername: isCreatingNew ? path(['username'], producerData) : path(['producer', 'username'], product),
          id: state?.id,
          ean: state?.EAN,
          renameFiles: true,
        },
      },
    });
  };

  const {
    importImagesRef,
    failedAIRequest,
    imageProcessErrors,
    isImportingImages,
    importingFiles,
    setImportingFiles,
    onImportImages,
    files,
    setFiles,
  } = useImportProductImages({
    getS3Requests,
    state,
    producer: isCreatingNew ? producerData : product?.producer,
  });
  keepRef.current.files = files;

  // ------------------------------- //

  const onDelete = () => {
    if (!confirmDelete) {
      setConfirmDelete(true);
      return;
    }

    removeProductMutation({
      variables: {
        productId: product?.id,
      },
    });

    setConfirmDelete(false);
  };

  const restoreProduct = () => {
    restoreProductMutation({
      variables: {
        productId: product?.id,
      },
    });
  };

  const onImagesRejected = images => {
    setImagesRejected(images);
  };

  const onImageActionClicked = image => {
    if (includes(image, imagesToBeRemoved)) {
      const toBeRemoved = without([image], imagesToBeRemoved);
      setImagesToBeRemoved(toBeRemoved);
    } else {
      const toBeRemoved = append(image, imagesToBeRemoved);
      const uniq = uniqBy(i => i.pictureUrl, toBeRemoved);
      setImagesToBeRemoved(uniq);
    }
  };

  const handleChange = ({ target: { name, value } }) => {
    // Enforce float if descriptive_size_amount
    setState({ ...state, [name]: value });
  };

  const handleRadioChange = event => {
    const name = event.target.name;
    const value = event.target.value;

    const formattedValue = value ? value === 'true' : null;

    setState({ ...state, [name]: formattedValue });
  };

  const handleBooleanChange = ({ target }, checked) => setState({ ...state, [target.name]: checked });

  const handleDropdownChange = event => {
    const stateName = event.target.name;
    const stateValue = event.target.value;

    const val = !stateValue || stateValue === '' ? null : stateValue;
    stateName && setState({ ...state, [stateName]: val });
  };

  const handleEANChange = event => {
    const name = event.target.name;
    let value = event.target.value;

    if (event.nativeEvent.inputType === 'insertText') {
      if (event.nativeEvent.data && !/^\d+$/.test(event.nativeEvent.data)) {
        // when user type a character which is not a digit
        return;
      }
    } else if (event.nativeEvent.inputType === 'insertFromPaste') {
      // remove white space from paste
      value = value.replace(/\s+/g, '');
    }

    // Enforce float if descriptive_size_amount
    const newState = { ...state, [name]: value };
    if (value && (value.trim().startsWith('23') || value.trim().startsWith('20'))) {
      if (isCreatingNew && (!state.descriptive_size_unit || state.descriptive_size_unit.trim() !== '')) {
        newState.descriptive_size_unit = 'GRAM_APPROXIMATE';
      }
    }
    setState(newState);
  };

  const handleChangePlaceOfActivity = ({ target: { name, value } }) => {
    const newState = {
      ...state,
    };
    newState[name] = value;
    if (
      value &&
      value.trim().includes('Sverige') &&
      (!state.country_of_manufacturing || state.country_of_manufacturing === '')
    ) {
      newState.country_of_manufacturing = 752;
    }
    setState(newState);
  };

  const isProductionMode = process.env.REACT_APP_AUTH_ENV === 'prod';

  const handleCheck = event => {
    setState({ ...state, quantity_in_stock: event.target.checked ? 0 : 1 });
  };

  async function submitApproval(isDraft) {
    state.isDraft = !!isDraft;
    setIsSubmitting(true);
    if (!state.isDraft) {
      try {
        const { data: uniqEANData } = await checkUniqEAN({
          id: state.id,
          EAN: state?.EAN,
          EAN2: state?.EAN2,
          storeId: state?.producerIsStore ? state?.producerId : null,
        });
        const isUniqEAN = !isProducer || (uniqEANData ? uniqEANData.checkUniqEAN : true);
        if (!isUniqEAN) {
          setIsSubmitting(false);
          return;
        }
      } catch (e) {
        console.error('Error checking Uniq EAN', e);
        setIsSubmitting(false);
        return;
      }
    }

    state.documents = await onUploadProductDocuments(state);
    keepRef.current.savingState = cloneDeep(state);
    keepRef.current.savingImages = sortedImages;

    let timeToCreateSeconds;
    if (isCreatingNew && viewStartTime.current) {
      timeToCreateSeconds = Math.round((Date.now() - viewStartTime.current) / 1000);
      viewStartTime.current = null;
    }

    const evt = isCreatingNew ? 'createProduct' : 'updateProduct';
    const eventData = {
      event: evt,
      product: {
        id: state?.id,
        name: state?.title,
        foodlaCategory: state?.foodlaCategory?.name,
      },
      ...(!!timeToCreateSeconds && { time_to_create_seconds: timeToCreateSeconds }),
    };

    if (isCreatingNew && searchParams.source) {
      Object.assign(eventData, {
        flow_id: searchParams.flowId,
        user_id: keycloakCtx?.keycloak?.tokenParsed?.sub,
        product_source: searchParams.source,
        source_ean: searchParams.ean,
        product_created_ean: state?.EAN, // Final EAN (may differ from source)
        flow_completed: true,
      });
    }

    window.dataLayer.push(eventData);

    if (isSuperuser && state.adminStatus === SUPERUSER_APPROVAL.ADMIN_APPROVED && approved) {
      state.approve = [];
      state.currentApprove = [];
    }

    const signedRequests = path(['getS3SignRequest', 'requests'], requestData);
    console.log('!!!sortedImages - signedRequests', signedRequests);
    console.log('!!!sortedImages', sortedImages);

    const allImageUrls = map(i => i.pictureUrl, sortedImages);
    const allToBeDeleted = map(i => i.pictureUrl, imagesToBeRemoved);
    const imagesToSave = without(allToBeDeleted, allImageUrls);

    const requestsForImagesToSave = isDefined(signedRequests)
      ? filter(r => includes(r.pictureUrl, imagesToSave), signedRequests)
      : [];
    console.log('!!!sortedImages - requestsForImagesToSave', requestsForImagesToSave);

    const addApoteaImage = image => {
      if (image?.pictureUrl && image.pictureUrl.trim() !== '') {
        const updatedImage = { ...image };
        const url = new URL(image.pictureUrl);
        if (image.isApoteaImage) {
          url.searchParams.set('APOTEA_IMAGE', '1');
        } else {
          url.searchParams.delete('APOTEA_IMAGE');
        }
        updatedImage.pictureUrl = decodeURI(url.href);
        return updatedImage;
      }
      return image;
    };
    const _allToBeDeleted = map(i => i.pictureUrl, imagesToBeRemoved);
    const _imagesToSave = sortedImages
      .filter(i => !_allToBeDeleted.includes(i.pictureUrl))
      .map(i => addApoteaImage(i).pictureUrl);

    let mutation = isCreatingNew ? createProductMutation : updateProduct;
    // const newProduct = product;
    // eslint-disable-next-line no-unused-expressions
    // newProduct?.approve?.map((x) => {
    //   x.__typename = 'Approve';
    // });
    console.log('!!!imagesToSave', imagesToSave);

    // Avoid uploading magic-upload images if we are going to bail out before saving.
    if (requestLoading || isImportingImages) {
      setIsSubmitting(false);
      return;
    }

    let recognizeImages = (state?.recognizeImages || []).filter(
      item => !fillImagesToBeRemoved.some(({ url }) => url === item.url)
    );
    const pendingAutofillImages = await onUploadRecognizeImages({
      autofillFiles,
      fillImagesToBeRemoved,
    });
    if (pendingAutofillImages.length) {
      recognizeImages = [...recognizeImages, ...pendingAutofillImages];
    }

    let mutationInput = getProductMutationInput(
      product,
      {
        ...state,
        recognizeImages,
      },
      userRole,
      _imagesToSave,
      isCreatingNew,
      rootCategory
    );
    console.log('!!!mutationInput 1', mutationInput);

    const replaceTabs = true;
    if (replaceTabs) {
      const input = mutationInput?.variables?.input;
      if (input) {
        const keys = Object.getOwnPropertyNames(input);
        keys.forEach(key => {
          if (ignoreTabsFields.includes(key)) {
            const value = input[key];
            if (isDefined(value)) {
              mutationInput.variables.input[key] = value.replace(/\t/g, '  ');
              console.log('!!!mutationInput 2', mutationInput);
            }
          }
        });
      }
    }

    console.log('!!!files', files);
    // console.log('!!!mutationInput', mutationInput);

    if (isCreatingNew) {
      // A few components are using "useState(state.{name})"
      // We have to reset state here, but not in "onCompleted",
      //    before these components are mounted again (when "showForm" become True)
      const initialState = getInitialState({}, producerData);
      setState({ ...initialState });
    }

    // Three cases:
    // 1. No images has been added.
    // 2. Images added but error when requesting S3 request.
    // 3. Images added and shall be uploaded.

    // 0. Ensure we don't prematurely save if images are still loading or processing
    if (requestLoading || isImportingImages) {
      setIsSubmitting(false);
      return;
    }

    // 1.
    if (requestsForImagesToSave.length === 0) {
      mutation(mutationInput);
      console.log('!!!mutationInput 3', mutationInput);
      setFiles([]);
      // Keep the existing images in the sorter until the refetched product replaces them.
      // Clearing them here made a failed mutation leave the form with no images,
      // a false "Produktbild för e-handel är obligatoriskt" error and a disabled button.
      if (isCreatingNew) setImagesSorted([]);
      return;
    }

    // 2.
    if (requestError) {
      // console.log('!!!save images 2');
      mutation(mutationInput);
      console.log('!!!mutationInput 4', mutationInput);
      return;
    }
    // 3.
    else if (requestsForImagesToSave.length > 0 && requestData && !requestError && !requestLoading) {
      setImageIsUploading(true);
      try {
        await uploadImages(files, requestsForImagesToSave);
        mutation(mutationInput);
        console.log('!!!mutationInput 5', mutationInput);
      } catch (e) {
        console.error('Error uploading images', e);
        mutationInput = isCreatingNew
          ? getProductMutationInput(product, state, userRole, [], isCreatingNew, rootCategory)
          : getProductMutationInput(product, state, userRole, allExistingProductImages, false, rootCategory);

        mutation(mutationInput);
        console.log('!!!mutationInput 6', mutationInput);
      }

      setFiles([]);
      setImageUploadError(false);
      setImageIsUploading(false);
      setUploadDone(true);
      if (isCreatingNew) setImagesSorted([]);
      setImagesRejected([]);
      setImagesToBeRemoved([]);
      setFillImagesToBeRemoved([]);
      setAutofillFiles([]);
    } else {
      // In case we fall through (e.g. requestLoading is still true), reset submitting state
      // since no mutation was fired and onCompleted/onError will never be called.
      setIsSubmitting(false);
    }
    // We do NOT call setIsSubmitting(false) here because the mutation might be in-flight.
    // We rely on onError/onCompleted in useMutation to reset isSubmitting.
  }

  function getUpdateSuccessMessage(data) {
    if (keepRef.current.savingState?.isDraft) return 'Utkast sparat.';
    if (isProducer) return 'Produkten har sparats och skickats för granskning.';
    return pathOr(errorMessage, ['updateProduct', 'message'], data);
  }

  function refetchQueries() {
    let queries = [];
    // let queries = [{ query: ALL_PRODUCTS_QUERY, variables: { filter: { tagState: PRODUCT_TAGSTATES.PENDING } } }];
    if (isSuperuser) {
      queries = queries.concat(queries, [
        // { query: SUPERUSER_STATISTICS_QUERY },
        // { query: DELETED_PRODUCTS_DETAILED_QUERY },
      ]);
    }
    const result = !isCreatingNew
      ? concat(queries, [
          { query: PRODUCT_INFO_FOR_UPDATE_QUERY, variables: { id: path(['id'], product) } },
          { query: GET_PRODUCT_BY_ID, variables: { id: path(['id'], product) } },
        ])
      : queries;
    return result;
  }

  const failedAI = path(['error'], failedAIRequest);
  const failedAIFileName = path(['imageName'], failedAIRequest);
  const failedAIMessage = path(['message'], failedAIRequest);

  const errorMessage = isCreatingNew ? 'Failed to create product...' : 'Failed to update product...';
  let feedback = <></>;

  // --------------- FEEDBACK ON ACTION ---------------- //
  // Loading state
  if (updateProductLoading || imageIsUploading || createProductLoading || isSubmitting) {
    feedback = (
      <div className={classes.feedbackContainer} style={{ height: 200 }}>
        <CircularSpinner />
        <p style={{ fontSize: 16, marginTop: 16, color: 'rgba(0, 0, 0, 0.6)' }}>Produkten sparas, vänta...</p>
      </div>
    );
  }
  // Response received
  else if (createProductData || updateProductData || createProductError || updateProductError) {
    let feedbackMessage;
    let success;

    const additionalSuccess = !imageUploadError;
    let additionalMessage = imageUploadError
      ? 'Failed to upload images. Contact support for help.'
      : uploadDone
      ? 'Images uploaded!'
      : '';

    if (isCreatingNew) {
      if (createProductError)
        feedback = (
          <ResponseSnackBar success={false} message={createProductError.message || 'Failed to create new product'} />
        );
    } else {
      if (updateProductError) {
        feedbackMessage = updateProductError.message || errorMessage;
        success = false;
      } else {
        success = path(['updateProduct', 'success'], updateProductData);
        feedbackMessage = success
          ? getUpdateSuccessMessage(updateProductData)
          : pathOr(errorMessage, ['updateProduct', 'message'], updateProductData);
      }

      feedback = (
        <ResponseSnackBar
          success={success}
          message={feedbackMessage}
          additionalSuccess={additionalSuccess}
          additionalMessage={additionalMessage}
        />
      );
    }
  }
  // Success message saved before the edit page reloaded this form
  else if (savedFeedback) {
    feedback = (
      <ResponseSnackBar
        success
        message={savedFeedback.message}
        additionalSuccess={savedFeedback.additionalSuccess}
        additionalMessage={savedFeedback.additionalMessage}
      />
    );
  }

  let imageRejection = <></>;
  if (!isEmpty(imagesRejected)) {
    let message = '';
    forEach(ir => {
      message = message.concat(` ${path(['file', 'path'], ir)} (w: ${ir.width}, h: ${ir.height}) `);
    }, imagesRejected);

    imageRejection = (
      <ResponseSnackBar
        success={false}
        message={message}
        onClosedCallback={() => setImagesRejected([])}
        title={
          imagesRejected.length > 1
            ? 'Images too small, must be at least 900x900'
            : 'Image too small, must be at least 900x900'
        }
        duration={15000}
      />
    );
  }

  // const [ingredient, setIngredient] = React.useState(undefined);

  // const [dimensions, setDimensions] = React.useState({});
  // getDimensions(sortedImages[0]?.pictureUrl).then(d => setDimensions(d));

  const {
    eanLengthError,
    eanControlError,
    eanWrongCoopStoreError,
    nonUniqError,
    eanNotOnlyDegit,
    icaStoreProcucerEanError,
  } = checkEANValue(state, uniqResult, isCreatingNew);

  let expandVitamins =
    isSuperuser &&
    (state.vitaminA ||
      state.vitaminD ||
      state.vitaminE ||
      state.vitaminK ||
      state.vitaminC ||
      state.tiamin ||
      state.riboflavin ||
      state.niacin ||
      state.vitaminB6 ||
      state.folsyra ||
      state.vitaminB12 ||
      state.biotin ||
      state.pantotensyra ||
      state.kalium ||
      state.klorid ||
      state.kalcium ||
      state.fosfor ||
      state.magnesium ||
      state.jarn ||
      state.zink ||
      state.koppar ||
      state.mangan ||
      state.fluorid ||
      state.selen ||
      state.krom ||
      state.molybden ||
      state.jod);

  const producerPage = isSuperuser ? `/superuser/producer/${state?.producerId}/edit` : `/me/${state?.producerId}/edit`;

  const isReachSubstanceRequired =
    isToy(state?.foodlaCategory, rootCategory) ||
    isElectric(state?.foodlaCategory, rootCategory) ||
    isJewelry(state?.foodlaCategory, rootCategory) ||
    isChemical(state?.foodlaCategory, rootCategory) ||
    isDetergent(state?.foodlaCategory, rootCategory) ||
    isCosmetic(state?.foodlaCategory, rootCategory) ||
    isSunscreen(state?.foodlaCategory, rootCategory);

  // Check EAN required
  const [focusedEAN, setFocusedEAN] = useState(false);

  const requireEANError = useMemo(() => {
    if (isCreatingNew && !focusedEAN && !state.isDraft) {
      return '';
    }

    if (isBlank(state.EAN)) {
      return 'Vänligen fyll i detta fält eller spara som utkast.';
    }
    return '';
  }, [focusedEAN, state, isCreatingNew]);
  const [openConfirmDraftDialog, setOpenConfirmDraftDialog] = useState(false);

  return (
    <ProductEditHistoryContext.Provider
      value={{
        historyData,
        historyLoading,
        expandHistoryAndScroll,
      }}
    >
    <ProductValidationContext.Provider value={productValidations}>
    <AiFieldVerdictContext.Provider value={aiFieldVerdicts}>
      <>
      {isSuperuser && !showMarkedComponent && (
        <div style={{ display: formHidden ? 'none' : undefined }}>
          <Alerts
            state={state}
            sortedImages={sortedImages}
            nonUniq={uniqResult}
            isCoopStoreProduct={isCoopStoreProduct}
            isNoHasUnpaidInvoices={!unpaidInvoiceData.error && !unpaidInvoiceData.list.length}
            categories={categories}
          />
        </div>
      )}
      {imageRejection}
      {feedback}
      {showMarkedComponent && (
        <MarkedProduct
          product={product}
          showActionButton={isSuperuser}
          onActionButtonPressed={restoreProduct}
          actionButtonTitle="Restore product"
        />
      )}
      {openConfirmDraftDialog && (
        <AlertDialog
          title="Spara produkten som utkast?"
          content="Du håller på att spara produkten som utkast. Utkast granskas ej och exporteras inte till återförsäljare. Vill du fortsätta spara som utkast?"
          cancelButtonText="Fortsätt redigera"
          submitButtonText="Spara som utkast"
          onCancel={() => setOpenConfirmDraftDialog(false)}
          onSubmit={() => {
            setOpenConfirmDraftDialog(false);
            submitApproval(true);
          }}
        />
      )}
      {!showMarkedComponent && (
        <div
          className={readOnly ? classes.readOnlyForm : undefined}
          style={{ display: formHidden ? 'none' : undefined }}
        >
          {isSuperuser && <ProducerNotAccepted product={product} />}

          <form
            className={classes.form}
            noValidate
            onSubmit={e => {
              e.preventDefault();
              if (readOnly) return;
              submitApproval();
            }}
            onKeyDown={e => {
              // FC-2041: Enter in a single-line field must not submit the product for review.
              if (e.key === 'Enter' && e.target instanceof HTMLInputElement) e.preventDefault();
            }}
            id={isCreatingNew ? 'create-product-form' : 'update-product-form'}
          >
            <Card className={classes.card}>
              {showTitleHeader && product?.title && (
                <h3 style={{ marginBottom: 0, textAlign: 'center' }}>
                  {product.title}
                  <p style={{ fontWeight: 400, margin: 0 }}>
                    {state.producerId && readOnly ? (
                      <a
                        href={`/producers/${state.producerId}/show`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="preview-allow-click"
                        style={{ color: '#3f51b5', textDecoration: 'underline' }}
                      >
                        {state.producerName}
                      </a>
                    ) : (
                      state.producerName
                    )}
                  </p>
                </h3>
              )}
              <div
                id="images"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flex: 1,
                  minHeight: isFood && isSuperuser && approve && state?.approve?.find(x => x.field === 'images') && 270,
                }}
              >
                <div style={{ width: '100%', overflow: 'hidden' }}>
                  {readOnly ? (
                    <ReadOnlyImageGallery
                      imageOnly
                      urls={[product?.image_src || '', ...(product?.additionalImages || [])]}
                    />
                  ) : isImportingImages ? (
                    <div className={classes.feedbackContainer} style={{ margin: 10 }}>
                      <CircularSpinner />
                      <p
                        style={{
                          fontSize: 12,
                          textAlign: 'center',
                        }}
                      >
                        Sygrid tar nu automatiskt bort bakgrunden från din bild
                      </p>
                      <CancelImportImageButton importingFiles={importingFiles} importImagesRef={importImagesRef} />
                    </div>
                  ) : (
                    <>
                      <ImageUploader
                        // containerStyle={{flex: 0.9}}
                        id="image_src"
                        newUi
                        images={sortedImages}
                        withOutImagePreview
                        onImportImages={onImportImages}
                        withLabel
                        product={state}
                        producer={isCreatingNew ? producerData : product?.producer}
                        labelOptions={{
                          heading: 'Produktbild för e-handel',
                          text: 'Den första bilden blir produktens huvudbild hos retailer. Behöver du bättre kvalitet? Klicka på FÖRBÄTTRA under en bild för att AI-förbättra den. Tips för bra produktbilder visas direkt under fältet.',
                          required: true,
                        }}
                        withDimensionCheck
                        onImagesRejected={onImagesRejected}
                        importImagesRef={importImagesRef}
                        setImportingFiles={setImportingFiles}
                      >
                        <ImageSorter
                          canImproveImage
                          newUi
                          showSizeWarning={isSuperuser}
                          state={state}
                          images={sortedImages}
                          onDeleteOrKeepImagePressed={onImageActionClicked}
                          onOrderChanged={setImagesSorted}
                          onAddedFiles={newFiles => {
                            const allImages = [...keepRef.current.files, ...newFiles];
                            setFiles(allImages);
                            getS3Requests(allImages);
                          }}
                          imagesToBeRemoved={imagesToBeRemoved}
                          showMetadata={true}
                          isDownload={isDownload}
                          isEdit={isEdit}
                          disableEdit={isCreatingNew}
                          isMagazine={state?.isMagazine}
                          showApotea={isApoteaProductProducer}
                        />
                      </ImageUploader>
                      {(failedAI || !!imageProcessErrors?.length) && (
                        <>
                          {failedAI && (
                            <>
                              <p id="ProductForm-AutoGenerateImage-Message-Error" className={classes.failedAIText}>
                                Failed to auto generate image for {failedAIFileName}
                              </p>
                              <p className={classes.failedAIMessagesText}>Reason: {`${failedAIMessage}`}</p>
                            </>
                          )}
                          {imageProcessErrors?.map(({ message, fileName }) => (
                            <>
                              <p id="ProductForm-AutoGenerateImage-Message-Error" className={classes.failedAIText}>
                                Failed to process image for {fileName}
                              </p>
                              <p className={classes.failedAIMessagesText}>Reason: {message}</p>
                            </>
                          ))}
                          <p className={classes.imageGuideText}>
                            Tip: See the Sygrid Foto Guide{' '}
                            <a href={LINKS.IMAGE_GUIDE} target="_blank" rel="noopener noreferrer">
                              here
                            </a>{' '}
                            for help with optimal product photos!
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
                {isSuperuser && approve && state?.approve?.find(x => x.field === 'images') && (
                  <div style={{ flex: 0.1, maxHeight: 24, alignSelf: 'center' }}>
                    <ThreeWaySwitch readOnly={readOnly} state={state} setState={setState} name="images" />
                    {isFood && (
                      <FormControlLabel
                        control={
                          <Switch
                            disabled={readOnly}
                            checked={state?.imageUnderProcess}
                            onChange={() => setState({ ...state, imageUnderProcess: !state?.imageUnderProcess })}
                            name="imageUnderProcess"
                            color="primary"
                          />
                        }
                        style={{ marginLeft: 5, marginTop: 5 }}
                        label="Picture under manual process"
                      />
                    )}
                  </div>
                )}
              </div>
              {isSuperuser && <Vision readOnly={readOnly} isFood={isFood} images={sortedImages} state={state} setState={setState} />}

              {isSuperuser && (
                <ImageHistory
                  sortedImages={sortedImages}
                  loading={loadingVersions}
                  loaded={loadedVersions}
                  versions={versions}
                  onTrigger={triggerLoadVersions}
                  onRestore={image => {
                    setImagesSorted(state => [...state, ...getImagesForSorter([image])]);
                  }}
                />
              )}
              {!readOnly && (
                <FillProductByImage
                  rootCategory={rootCategory}
                  producerData={producerData}
                  isChangedBrand={isChangedBrand}
                  isCreatingNew={isCreatingNew}
                  fillImagesToBeRemoved={fillImagesToBeRemoved}
                  setFillImagesToBeRemoved={setFillImagesToBeRemoved}
                  autofillFiles={autofillFiles}
                  setAutofillFiles={setAutofillFiles}
                  isFood={isFood}
                  state={state}
                  setState={setState}
                  onChangedState={() => setIsAiChangedState(true)}
                  approve={isSuperuser && approve}
                />
              )}
            </Card>

            {!!readOnly && !!state?.recognizeImages?.length && (
              <Card className={classes.card}>
                <h3>Bilder & dokument med produktinformation</h3>
                <ReadOnlyImageGallery
                  urls={state.recognizeImages.map(item => item.url)}
                />
              </Card>
            )}

            <Card className={classes.card}>
              <h3>Produktinformation</h3>

              <Category
                readOnly={readOnly}
                product={product}
                sortedImages={sortedImages}
                isSuperuser={isSuperuser}
                isUserStore={isUserStore}
                userRole={userRole}
                state={state}
                setState={setState}
                approve={approve && isSuperuser}
                rootCategory={rootCategory}
                categories={categories}
                categoryError={categoryError}
                categoryLoading={categoryLoading}
                fieldVisibility={visibleFields}
              />

              <Title
                readOnly={readOnly}
                producerData={producerData}
                isCreatingNew={isCreatingNew}
                userRole={userRole}
                state={state}
                setState={setState}
                approve={approve && isSuperuser}
                icaExportData={icaExportData}
                icaGeneratedNameData={icaGeneratedNameData}
                woltExportData={woltExportData}
                coopExportData={coopExportData}
                apoteaExportData={apoteaJsonExportData}
                apoteaGeneratedNameData={apoteaGeneratedNameData}
                rootCategory={rootCategory}
              />

              {isSuperuser && state?.isMagazine && <AlternativeTitle readOnly={readOnly} state={state} setState={setState} />}

              <Grid container={true}>
                <Grid item={true} xs={state?.EAN2 && state.EAN2.trim() !== '' && mdUp ? 6 : 12}>
                  <InputTextField
                    readOnly={readOnly}
                    style={{ marginTop: 7, marginRight: 5 }}
                    label="EAN/GTIN kod på konsumentförpackningen"
                    inputName="EAN"
                    id="EAN"
                    onChange={handleEANChange}
                    onFocus={() => setFocusedEAN(true)}
                    setState={setState}
                    approve={isSuperuser && approve}
                    state={state}
                    disabled={state?.isMagazine}
                    forceRed={
                      (!!eanLengthError && !state.ignoreEANLengthError) ||
                      !!eanControlError ||
                      !!eanWrongCoopStoreError ||
                      !!nonUniqError ||
                      !!eanNotOnlyDegit ||
                      !!requireEANError ||
                      !!icaStoreProcucerEanError
                    }
                    value={state.EAN}
                    withLabel
                    inputClassName="data-hj-allow"
                    labelOptions={{
                      heading: 'EAN-kod (13 eller 8 siffror)',
                      text: "EAN/GTIN som konsumentförpackningen är märkt med. Normalt EAN/GTIN-13 alternativt EAN/GTIN-8. Inledande nollor är giltiga och måste anges (en 12-siffrig UPC-kod skrivs som 13 siffror med en '0' först).",
                      required: true,
                    }}
                    errorText={requireEANError}
                    helpText="Obligatoriskt för att aktivera produkten, men kan sparas som utkast utan att fyllas i."
                  />
                  {!!eanNotOnlyDegit && (
                    <span style={{ fontWeight: 'bold', color: 'orangered' }}>Only digits allowed</span>
                  )}
                </Grid>
                {(eanLengthError || state?.ignoreEANLengthError) && isSuperuser && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={readOnly}
                        checked={state?.ignoreEANLengthError}
                        onChange={(event, checked) => setState({ ...state, ignoreEANLengthError: checked })}
                        name="ignoreEANLengthError"
                        color="primary"
                        style={{ paddingLeft: 0 }}
                      />
                    }
                    labelPlacement="end"
                    label="Ignore EAN length error"
                  />
                )}
                {state?.EAN2 && state.EAN2.trim() !== '' && (
                  <Grid item={true} xs={mdUp ? 6 : 12}>
                    <InputTextField
                      readOnly={readOnly}
                      style={{ marginTop: 7, marginLeft: 5 }}
                      label="EAN med justerade vikt/pris-siffror och/eller justerad kontrollsiffra"
                      inputName="EAN2"
                      // onChange={handleEANChange}
                      // setState={setState}
                      // approve={isFood && isSuperuser && approve}
                      // state={state}
                      // required
                      // forceRed={!!eanError || !!eanError2}
                      value={state.EAN2}
                      disabled={true}
                      withLabel
                      shrink={true}
                      labelOptions={{
                        heading: '.',
                      }}
                    />
                  </Grid>
                )}
              </Grid>
              {((eanLengthError && !state.ignoreEANLengthError) ||
                eanControlError ||
                eanWrongCoopStoreError ||
                icaStoreProcucerEanError ||
                nonUniqError) && (
                <span style={{ fontWeight: 'bold', color: 'orangered' }}>
                  {eanLengthError ||
                    eanControlError ||
                    eanWrongCoopStoreError ||
                    icaStoreProcucerEanError ||
                    nonUniqError}
                </span>
              )}
              {!!eanControlError && !readOnly && (
                <TagLabel
                  space
                  type="info"
                  icon={<InfoOutlinedIcon />}
                  onClick={() => {
                    setState(oldState => ({
                      ...oldState,
                      EAN: `${state?.EAN?.slice(0, 12)}${getControlDigit(state?.EAN || '')}`,
                    }));
                  }}
                >
                  <span style={{ marginRight: 2 }}>Rätt EAN-kod bör vara:</span>
                  <strong style={{ marginRight: 2 }}>
                    {`${state?.EAN?.slice(0, 12)}${getControlDigit(state?.EAN || '')}`}.
                  </strong>
                  <span>Klicka här för att uppdatera</span>
                </TagLabel>
              )}

              <PurchasingData
                approve={isSuperuser && approve}
                state={state}
                setState={setState}
                readOnly={readOnly}
              />

              {visibleFields.eggPackerApprovalNumber && (
                <>
                  <InputLabel
                    heading="Godkännandenummer för äggpackeri"
                    text="Godkännande nummer för äggpackeri måste finnas på förpackningen."
                    link="https://www.livsmedelsverket.se/livsmedel-och-innehall/mat-och-dryck/kott-kyckling-och-agg/hur-ska-agg-markas"
                  />
                  <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                    <InputTextField
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                      inputName="eggPackerApprovalNumber"
                      value={state.eggPackerApprovalNumber}
                      placeholder="Ex. SE001"
                      onChange={handleChange}
                    />
                    {isSuperuser && approve && state?.approve?.find(x => x.field === 'eggPackerApprovalNumber') && (
                      <ThreeWaySwitch
                        readOnly={readOnly}
                        state={state}
                        style={{ flex: 0.1, height: 56, marginBottom: 4 }}
                        setState={setState}
                        name="eggPackerApprovalNumber"
                      />
                    )}
                  </div>
                </>
              )}

              <ShortText
                readOnly={readOnly}
                state={state}
                setState={setState}
                approve={isSuperuser && approve}
                sortedImages={sortedImages}
                coopExportProduct={coopExportData.data}
                rootCategory={rootCategory}
              />

              {visibleFields.shortSalesDescription && (
                <ShortSalesDescription
                  readOnly={readOnly}
                  approve={isSuperuser && approve}
                  state={state}
                  setState={setState}
                />
              )}

              {visibleSections.contents && visibleFields.animalFeedType && (
                <AnimalFeedType readOnly={readOnly} state={state} setState={setState} rootCategory={rootCategory} />
              )}

              {visibleSections.contents && visibleFields.ingredient_statement && (
                <Ingredients
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  approve={isFood && approve && isSuperuser}
                  userRole={userRole}
                  rootCategory={rootCategory}
                />
              )}

              {visibleSections.fish && (
                <FishFields readOnly={readOnly} approve={approve && isSuperuser} state={state} setState={setState} />
              )}

              {visibleSections.feed && (
                <FeedFields
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  rootCategory={rootCategory}
                  approve={approve && isSuperuser}
                />
              )}

              {visibleSections.feed && (
                <AnimalFields
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  rootCategory={rootCategory}
                  approve={approve && isSuperuser}
                />
              )}

              {visibleSections.ingredients && visibleFields.non_food_ingredients && (
                <NonFoodIngredients
                  readOnly={readOnly}
                  approve={isSuperuser && approve}
                  userRole={userRole}
                  state={state}
                  setState={setState}
                  rootCategory={rootCategory}
                  isCreatingNew={isCreatingNew}
                />
              )}

              <Labels
                readOnly={readOnly}
                state={state}
                userRole={userRole}
                setState={setState}
                approve={isSuperuser && approve}
                rootCategory={rootCategory}
              />

              {visibleSections.nutrition && (
                <Nutrition
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  approve={isFood && isSuperuser && approve}
                  isSupplement={visibleSections.substances}
                />
              )}
              {/*
              { isNonFood &&
                <GrossWeight
                  state={state}
                  setState={setState}
                  name="gross_weight"
                />
              } */}

              {visibleSections.vitamins && (
                <Vitamins
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  expand={expandVitamins || readOnly}
                  approve={isFood && isSuperuser && approve}
                />
              )}

              {visibleSections.substances && (
                <OtherSubstances readOnly={readOnly} state={state} setState={setState} />
              )}

              {visibleSections.properties && visibleFields.color && (
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                      <div style={{ flexGrow: 1 }}>
                      <GenericField
                        readOnly={readOnly}
                        state={state}
                        setState={setState}
                        label="Färg"
                        field="color"
                        required={false}
                        hideComponentLabel={readOnly}
                      />
                      </div>
                      {approve && state?.approve?.find(x => x.field === 'color') && (
                        <ThreeWaySwitch
                          readOnly={readOnly}
                          state={state}
                          setState={setState}
                          name="color"
                          style={{ marginTop: 40 }}
                        />
                      )}
                    </div>
                )}

              {visibleSections.properties && (
                  <>
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                      <div style={{ flexGrow: 1 }}>
                        <GenericField
                          readOnly={readOnly}
                          state={state}
                          setState={setState}
                          label="Material"
                          hideComponentLabel={readOnly}
                          field="material"
                          required={false}
                        />
                      </div>
                      {isSuperuser && approve && state?.approve?.find(x => x.field === 'material') && (
                        <ThreeWaySwitch
                          readOnly={readOnly}
                          state={state}
                          setState={setState}
                          name="material"
                          style={{ marginTop: 40 }}
                        />
                      )}
                    </div>
                    <Dimensions
                      approve={approve && isSuperuser}
                      state={state}
                      setState={setState}
                      rootCategory={rootCategory}
                      readOnly={readOnly}
                    />
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                      <div style={{ flexGrow: 1 }}>
                        <GenericField
                          readOnly={readOnly}
                          state={state}
                          setState={setState}
                          label="Volym"
                          field="capacity"
                          required={false}
                          hideComponentLabel={readOnly}
                        />
                      </div>
                      {isSuperuser && approve && state?.approve?.find(x => x.field === 'capacity') && (
                        <ThreeWaySwitch
                          readOnly={readOnly}
                          state={state}
                          setState={setState}
                          name="capacity"
                          style={{ marginTop: 40 }}
                        />
                      )}
                    </div>
                  </>
                )}

              {visibleSections.candles && (
                <BurningTime approve={isSuperuser && approve} readOnly={readOnly} state={state} setState={setState} />
              )}

              {visibleSections.yarn && (
                <SewingKnittingYarn
                  readOnly={readOnly}
                  approve={approve && isSuperuser}
                  isCreatingNew={isCreatingNew}
                  state={state}
                  userRole={userRole}
                  setState={setState}
                />
              )}
              {visibleSections.snus && (
                <WhiteSnus
                  readOnly={readOnly}
                  approve={approve && isSuperuser}
                  isCreatingNew={isCreatingNew}
                  state={state}
                  userRole={userRole}
                  setState={setState}
                />
              )}

              {visibleSections.batteries && (
                <Batteries
                  readOnly={readOnly}
                  state={state}
                  approve={isSuperuser && approve}
                  setState={setState}
                />
              )}

              {visibleSections.lamps && (
                <ElectricLamp readOnly={readOnly} approve={approve && isSuperuser} state={state} setState={setState} />
              )}

              <Descriptive
                readOnly={readOnly}
                state={state}
                setState={setState}
                userRole={userRole}
                approve={approve && isSuperuser}
                isCreatingNew={isCreatingNew}
                isFood={isFood}
                isCoopStoreProduct={isCoopStoreProduct}
              />

              <SalesType readOnly={readOnly} state={state} setState={setState} approve={approve && isSuperuser} />

              {visibleSections.grossWeight && (
                <GrossWeight
                  readOnly={readOnly}
                  approve={isSuperuser && approve}
                  state={state}
                  setState={setState}
                  showLabel={true}
                />
              )}

              {visibleSections.dimensions && (
                <GrossDimensions
                  readOnly={readOnly}
                  approve={isSuperuser && approve}
                  state={state}
                  setState={setState}
                />
              )}

              {/* { isNonFood &&
                <PackageSize
                  state={state}
                  setState={setState}
                />
              } */}

              <Temperature readOnly={readOnly} state={state} setState={setState} approve={isSuperuser && approve} />

              {visibleSections.preparation && (
                <>
                  <InputLabel
                    heading="Tillagningsanvisning"
                    text="För vissa produkter är en tillagningsanvisning särskilt viktig av säkerhetsskäl, till exempel för kyckling."
                  />
                  <div style={{ display: 'flex', width: '100%', alignItems: 'start' }}>
                     <div style={{ flex: 1 }}>
                      <InputTextField
                        readOnly={readOnly}
                        multiline
                        multilineRows={2}
                        multilineMax={10}
                        state={state}
                        setState={setState}
                        inputName="preparationInstructions"
                        value={state.preparationInstructions}
                        placeholder="Ex. Produkten måste värmas upp grundligt före konsumtion"
                        onChange={handleChange}
                      />
                    </div>
                    {isSuperuser && approve && state?.approve?.find(x => x.field === 'preparationInstructions') && (
                      <ThreeWaySwitch
                        readOnly={readOnly}
                        state={state}
                        setState={setState}
                        name="preparationInstructions"
                        style={{ marginTop: 24 }}
                      />
                    )}
                  </div>
                </>
              )}

              {visibleSections.preparedForm && (
                <>
                  <InputLabel
                    heading="Beredningsform"
                    required={!!productValidations.requiredFields.preparedForm}
                    text="Beredningsform beskriver den formen produkten tar för att tas eller ges till en person."
                  />
                  <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                    <ListDropDown
                      readOnly={readOnly}
                      disableLabel={true}
                      listData={preparedForm}
                      value={state.preparedForm}
                      targetName="preparedForm"
                      handleChange={handleDropdownChange}
                      displayEmpty={true}
                      style={{ flexGrow: 1, overflow: 'hidden' }}
                    />
                    {approve && state?.approve?.find(x => x.field === 'preparedForm') && (
                      <ThreeWaySwitch
                        readOnly={readOnly}
                        state={state}
                        style={{ height: 56, marginBottom: 10 }}
                        setState={setState}
                        name="preparedForm"
                      />
                    )}
                  </div>
                </>
              )}

              {visibleSections.dosage && (
                  <>
                    <InputLabel
                      heading="Användningsinstruktioner och dosering"
                      text="Ex. Blanda pulvret med 200 ml vatten och värm därefter till ät-temperatur (max 60 °C). Använd inte produkten som din enda näringskälla längre än 8 veckor eller upprepade gånger under kortare perioder, utan medicinsk rådgivning."
                    />
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                      <InputTextField
                        readOnly={readOnly}
                        state={state}
                        setState={setState}
                        multiline
                        multilineRows={1}
                        multilineMax={20}
                        inputName="dosageAndUsageInstructions"
                        value={state.dosageAndUsageInstructions}
                        placeholder="Användningsinstruktioner och dosering, inklusive eventuella försiktighetsåtgärder"
                        onChange={handleChange}
                      />
                      {approve && state?.approve?.find(x => x.field === 'dosageAndUsageInstructions') && (
                        <ThreeWaySwitch
                          readOnly={readOnly}
                          state={state}
                          style={{ height: 56, marginBottom: 2 }}
                          setState={setState}
                          name="dosageAndUsageInstructions"
                        />
                      )}
                    </div>
                  </>
                )}

              {visibleSections.hazards && (
                <HazardFields
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  rootCategory={rootCategory}
                  approve={approve && isSuperuser}
                />
              )}

              {/* { isNonFood &&
                <GenericField
                  state={state}
                  setState={setState}
                  label='Tillverkningsland'
                  field='country_of_origin'
                />
              } */}

              <InputLabel
                heading="Avfallshantering och återvinningsinformation"
                text="Information om hur produkten ska avfallshanteras och återvinnas."
              />
              <div style={{ flex: 1, display: 'flex', gap: 4, alignItems: 'center' }}>
                <InputTextFieldDebounced
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  multiline
                  multilineRows={2}
                  multilineMax={20}
                  inputName="wasteManagementAndRecyclingInformation"
                  value={state.wasteManagementAndRecyclingInformation}
                  onChange={handleChange}
                />
                {isSuperuser &&
                  approve &&
                  state?.approve?.find(x => x.field === 'wasteManagementAndRecyclingInformation') && (
                    <ThreeWaySwitch readOnly={readOnly} name="wasteManagementAndRecyclingInformation" state={state} setState={setState} />
                  )}
              </div>

              {visibleSections.origin && (
                <InputTextField
                  readOnly={readOnly}
                  hideComponentLabel={readOnly}
                  style={{ marginTop: 7 }}
                  label="Ursprungsland och härkomstplats"
                  multiline
                  inputName="place_of_item_activity"
                  onChange={handleChangePlaceOfActivity}
                  setState={setState}
                  approve={isSuperuser && approve && !!state?.approve?.find(x => x.field === 'place_of_item_activity')}
                  state={state}
                  multilineRows={1}
                  multilineMax={20}
                  value={state.place_of_item_activity}
                  variant="outlined"
                  withLabel
                  labelOptions={{
                    heading: 'Ursprungsland och härkomstplats',
                    text: 'Notera att om den primära ingrediensen (utgör mer än 50% av livsmedlet) har annat ursprung än livsmedlet som helhet så krävs även uppgift om dess ursprung här.',
                    link: 'http://kontrollwiki.livsmedelsverket.se/artikel/47/ursprungsmarkning',
                  }}
                />
              )}

              {visibleSections.manufacturing && (
                <CountryOfManufacturing
                  readOnly={readOnly}
                  approve={isSuperuser && approve}
                  state={state}
                  setState={setState}
                  rootCategory={rootCategory}
                />
              )}

              {visibleSections.characteristics && (
                <>
                  <InputLabel
                    heading="Ytterligare egenskaper"
                    text="Ytterligare egenskaper som konsumenten kan använda för att söka efter produkter online listas här. Du kan välja flera alternativ."
                  />
                  <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <MultipleSelect
                      readOnly={readOnly}
                      disableLabel={true}
                      listData={additionalCharacteristics}
                      value={state?.additionalCharacteristics ?? []}
                      targetName="additionalCharacteristics"
                      handleChange={handleDropdownChange}
                      style={{ flexGrow: 1 }}
                    />
                    {isSuperuser && approve && state?.approve?.find(x => x.field === 'additionalCharacteristics') && (
                      <ThreeWaySwitch
                        readOnly={readOnly}
                        state={state}
                        setState={setState}
                        name="additionalCharacteristics"
                      />
                    )}
                  </div>
                </>
              )}

              {/* TODO:
              { isFood &&
                <InputTextField
                  style={{ marginTop: 7 }}
                  label="Ytterligare obligatoriska uppgifter för vissa typer eller kategorier av livsmedel"
                  multiline
                  inputName="additional_required_information"
                  onChange={handleChange}
                  setState={setState}
                  approve={isFood && isSuperuser && approve}
                  state={state}
                  multilineRows={2}
                  multilineMax={20}
                  value={state.additional_required_information}
                  variant="outlined"
                  withLabel
                  labelOptions={{
                    heading: 'Ytterligare obligatoriska uppgifter för vissa typer eller kategorier av livsmedel',
                    text: 'Ange här om det finns mer nödvändig information som måste anges gällande denna produkt.',
                  }}
                />
              } */}

              {/* {state.unit && state.unit.length > 0 && <Typography>{state.unit}</Typography>} */}

              {/* <StockToggleButton quantity_in_stock={state.quantity_in_stock} handleCheck={handleCheck} /> */}

              <Brand
                readOnly={readOnly}
                approve={isSuperuser && approve}
                state={state}
                setState={setState}
                isFood={visibleFields.brand_food}
                onChangedBrand={() => setChangedBrand(true)}
              />

              <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <InputTextFieldDebounced
                    readOnly={readOnly}
                    label={readOnly ? undefined : 'Ex. East Import AB'}
                    dense={false}
                    inputName="nameNordicDistributor"
                    state={state}
                    setState={setState}
                    withLabel
                    inputClassName="data-hj-allow"
                    labelOptions={{
                      required: !!productValidations.requiredFields.nameNordicDistributor,
                      heading: 'Namn på nordisk distributör',
                    }}
                  />
                </div>
                {isSuperuser && approve && state?.approve?.find(x => x.field === 'nameNordicDistributor') && (
                  <ThreeWaySwitch
                    readOnly={readOnly}
                    state={state}
                    setState={setState}
                    name="nameNordicDistributor"
                    style={{ marginTop: 42 }}
                  />
                )}
              </div>

              {visibleSections.contact && (
                <ConsumerContact
                  approve={isSuperuser && approve}
                  isSuperuser={isSuperuser}
                  state={state}
                  setState={setState}
                  readOnly={readOnly}
                />
              )}

              <SearchTerms
                readOnly={readOnly}
                approve={isSuperuser && approve}
                state={state}
                userRole={userRole}
                setState={setState}
              />
            </Card>

            {visibleSections.prices && (
              <Card className={classes.card} style={{ paddingBottom: 20 }}>
                <h3 style={{ marginBottom: 0 }}>
                  Apotea-priser
                  <RequiredAsterisk field="apoteaListPrice" />
                </h3>
                <p style={{ color: 'rgba(0, 0, 0, 0.54)', marginBottom: 16, marginTop: 4 }}>
                  Kommersiella villkor mellan leverantör och Apotea. Endast synliga för Apotea-anslutna producenter.
                </p>

                <ApoteaPrices
                  approve={isSuperuser && approve}
                  state={state}
                  setState={setState}
                  readOnly={readOnly}
                  rootCategory={rootCategory}
                />
              </Card>
            )}

            <Card className={classes.card}>
              {(visibleSections.orderable || visibleSections.despatch || visibleSections.packQuantities || visibleSections.dates || visibleSections.commodity) && (
                <LogisticQuestionsWrapper state={state} isApoteaProducer={isApoteaProducer}>
                  {visibleSections.orderable && (
                    <OrderableUnitFields
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                      isDespatchUnitsChanged={isDespatchUnitsChanged}
                    />
                  )}

                  {visibleSections.despatch && (
                    <DespatchUnitFields
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                      setChanged={setIsDespatchUnitsChanged}
                    />
                  )}

                  {visibleSections.orderable && (
                    <EANForStorePack readOnly={readOnly} uniqResult={!!uniqResult} state={state} setState={setState} />
                  )}

                  {visibleSections.packQuantities && (
                    <QtyOfBaseItemFields
                      approve={isSuperuser && approve}
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                      showApoteaFields={showApoteaFields}
                    />
                  )}

                  {visibleSections.dates && (
                    <PurchaseRelatedFields
                      approve={isSuperuser && approve}
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                    />
                  )}

                  {visibleSections.commodity && (
                    <CommodityCode
                      readOnly={readOnly}
                      approve={isSuperuser && approve}
                      state={state}
                      setState={setState}
                    />
                  )}
                </LogisticQuestionsWrapper>
              )}

              {visibleSections.location && (
                <Address
                  readOnly={readOnly}
                  isCreatingNew={isCreatingNew}
                  state={state}
                  setState={setState}
                  approve={isSuperuser && approve}
                  product={product}
                />
              )}

              <BasicData
                approve={isSuperuser && approve}
                readOnly={readOnly}
                state={state}
                setState={setState}
                rootCategory={rootCategory}
              />

              {/* {isSuperuser && (
                <Details state={state} setState={setState} />
              )} */}
              {/*{isSuperuser && (
                <ConsumerPack state={state} setState={setState} />
              )}

              {isSuperuser && (
                <StorePack state={state} setState={setState} />
              )}

              {isSuperuser && (
                <Transport state={state} setState={setState} />
              )}

              {isSuperuser && (
                <PalletLayer state={state} setState={setState} />
              )}

              {isSuperuser && (
                <Pallet state={state} setState={setState} />
              )}

              {isSuperuser && (
                <Price state={state} setState={setState} />  
              )} */}

              {visibleSections.weightControl && (
                <>
                  <InputLabel
                    heading="Ange kategori om produkten är för viktminskning"
                    text="Livsmedel för viktkontroll har en speciell sammansättning för användning i energibegränsade dieter och produceras för att ersätta måltider under dagen."
                    link="https://kontrollwiki.livsmedelsverket.se/artikel/77/komplett-kostersattning-for-viktkontroll"
                    required={!!productValidations.requiredFields.categoryWeightloss}
                  />
                  <div style={{ display: 'flex', width: '100%', alignItems: 'start' }}>
                    <div style={{ flex: 1 }}>
                      <ListDropDown
                        readOnly={readOnly}
                        disableLabel={true}
                        listData={categoryWeightloss}
                        value={state?.categoryWeightloss}
                        targetName="categoryWeightloss"
                        handleChange={handleDropdownChange}
                        displayEmpty={true}
                      />
                    </div>
                    {isSuperuser && approve && state?.approve?.find(x => x.field === 'categoryWeightloss') && (
                      <ThreeWaySwitch
                        readOnly={readOnly}
                        state={state}
                        setState={setState}
                        name="categoryWeightloss"
                        style={{ marginTop: 10 }}
                      />
                    )}
                  </div>
                </>
              )}

              {visibleSections.feedCompliance && (
                <FeedApprovalFields
                  readOnly={readOnly}
                  state={state}
                  setState={setState}
                  userRole={userRole}
                  approve={approve && isSuperuser}
                />
              )}

              <AdditionalGroupFields readOnly={readOnly} state={state} setState={setState} rootCategory={rootCategory} />

              {visibleSections.cosmeticCompliance && (
                <SunScreenFields readOnly={readOnly} state={state} setState={setState} rootCategory={rootCategory} />
              )}

              {visibleSections.reach && (
                <ReachSubstancesFields readOnly={readOnly} state={state} setState={setState} />
              )}

              {visibleSections.reach && visibleFields.regulatedSubstance && (
                  <>
                    <InputLabel
                      heading="Ange ämne(n)"
                      required={!!productValidations.requiredFields.regulatedSubstance}
                      text="Kom ihåg att ladda upp ett tillstånd för användning i din Sygrid profil. Vänligen märk ditt dokument på lämpligt sätt, t. ex. “Tillstånd för användning av kromtrioxid.”"
                      link={producerPage}
                    />
                    <InputTextField
                      readOnly={readOnly}
                      state={state}
                      setState={setState}
                      inputName="regulatedSubstance"
                      value={state.regulatedSubstance}
                      placeholder="Ex. Kromtrioxid. Listad separerad med komma"
                      onChange={handleChange}
                    />

                    <span className={classes.note}>
                      **För varje listat ämne måste du ladda upp ett tillstånd för användning under certifieringar i{' '}
                      <a href={producerPage} target="_blank" rel="noopener noreferrer" className={classes.noteLink}>
                        din Sygrid-profil
                      </a>
                      .
                    </span>
                  </>
                )}

              {visibleSections.hazardousSubstances && (
                <HazardousSubstancesFields readOnly={readOnly} state={state} setState={setState} />
              )}

              {visibleSections.medical && (
                <MedicalTechnologyFields readOnly={readOnly} state={state} setState={setState} />
              )}

              <QualityReviewFields
                readOnly={readOnly}
                state={state}
                approve={approve && isSuperuser}
                setState={setState}
                rootCategory={rootCategory}
                userRole={userRole}
                showApoteaFields={showApoteaFields}
              />

              <ProductDocuments
                readOnly={readOnly}
                isCreatingNew={isCreatingNew}
                state={state}
                product={product}
                onChangeDocuments={(documents) => setState({ ...state, documents: documents })}
              />

              {isSuperuser && <ProducerInfo readOnly={readOnly} state={state} setState={setState} />}

              {isSuperuser && <BulkImportFile product={product} />}

              {!readOnly && enableChat && !isCreatingNew && <Chat productId={state.id} />}

              {isSuperuser && (
                <React.Suspense fallback={<CircularSpinner />}>
                  <CoopExportPreview coopExportData={coopExportData} />
                </React.Suspense>
              )}
              {isSuperuser && (
                <React.Suspense fallback={<CircularSpinner />}>
                  <ApoteaExportPreview apoteaExportData={apoteaExportData} />
                </React.Suspense>
              )}
              {isSuperuser && (
                <React.Suspense fallback={<CircularSpinner />}>
                  <ApoteaExportJsonPreview apoteaExportData={apoteaJsonExportData} />
                </React.Suspense>
              )}
              {isSuperuser && (
                <React.Suspense fallback={<CircularSpinner />}>
                  <IcaExportPreview icaExportData={icaExportData} />
                </React.Suspense>
              )}
              {isSuperuser && (
                <React.Suspense fallback={<CircularSpinner />}>
                  <WoltExportPreview
                    state={state}
                    images={sortedImages}
                    setWoltExportData={setWoltExportData}
                    isSubmitting={isSubmitting}
                  />
                </React.Suspense>
              )}
              {isSuperuser && state.id && !isCreatingNew && (
                <div id="product-edit-history-section">
                  <ProductEditHistory
                    productId={state.id}
                    rootCategory={rootCategory}
                    categories={categories}
                    producerIsStore={state.producerIsStore}
                    expanded={historyExpanded}
                    onExpand={(e, isExp) => setHistoryExpanded(isExp)}
                    highlightedField={highlightedField}
                  />
                </div>
              )}
              {isSuperuser && state.id && !isCreatingNew && <Approvements productId={state.id} />}

              {!readOnly && (
                <>
                  <Divider style={{ marginTop: 32, marginBottom: 32 }} />
                  <Review
                    state={state}
                    setState={setState}
                    userRole={userRole}
                    isAiChangedState={isAiChangedState}
                    isCreatingNew={isCreatingNew}
                    product={product}
                  />

                  <SubmitButton
                    state={state}
                    savedProduct={product}
                    readOnly={readOnly}
                    saving={formHidden}
                    isFood={isFood}
                    userRole={userRole}
                    isCreatingNew={isCreatingNew}
                    approved={approved}
                    showEANError={
                      (!state.ignoreEANLengthError && eanLengthError) ||
                      eanWrongCoopStoreError ||
                      icaStoreProcucerEanError
                    }
                    showNonUniqEANError={nonUniqError}
                    showCategoryError={showCategoryError}
                    images={sortedImages}
                    imagesToBeRemoved={imagesToBeRemoved}
                    isNoHasUnpaidInvoices={
                      !unpaidInvoiceData.loading && !unpaidInvoiceData.error && !unpaidInvoiceData.list.length
                    }
                    rootCategory={rootCategory}
                    imageProcessingStatus={
                      isImportingImages
                        ? 'Tar bort bakgrund och optimerar bild...'
                        : requestLoading
                        ? 'Synkroniserar uppladdning...'
                        : ''
                    }
                    onSubmitDraft={
                      !readOnly && !product?.wasApproved && product?.adminStatus !== SUPERUSER_APPROVAL.ADMIN_APPROVED
                      ? () => setOpenConfirmDraftDialog(true)
                      : undefined
                    }
                  />
                </>
              )}
              {markedForRemoval && !showMarkedForRemovalComponent && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                  <span style={{ fontWeight: 'bold', fontSize: 16, color: COLORS.mainRed }}>
                    Producer has requested this product to be removed
                  </span>
                </div>
              )}
              {isSuperuser && false && (
                <Button
                  onClick={onDelete}
                  fullWidth
                  variant="contained"
                  color="secondary"
                  className={classes.deleteButton}
                >
                  <span className={confirmDelete ? classes.confirmDeleteText : classes.deleteText}>
                    {confirmDelete ? 'Click again if you are sure!' : 'Delete product'}
                  </span>
                </Button>
              )}
            </Card>
          </form>
        </div>
      )}
      {!readOnly && (
        <AIReviewer
          state={state}
          userRole={userRole}
          setState={setState}
          rootCategory={rootCategory}
          categoriesLoading={categoryLoading}
        />
      )}
      {isCreatedFirstProduct && <FirstProductDialog isDraft={keepRef.current.savingState?.isDraft} />}
    </>
    </AiFieldVerdictContext.Provider>
    </ProductValidationContext.Provider>
    </ProductEditHistoryContext.Provider>
  );
};

export default ProductForm;
